import CustomModal from "../../commons/modals/CustomModal";
import { Button } from "@progress/kendo-react-buttons";
import { Field, Form, FormElement, FormRenderProps } from "@progress/kendo-react-form";
import { required } from "../../commons/forms/Validators";
import { FormDatePicker } from "../../commons/forms/FormDatePicker";
import { dateToBdFormat, getDateWithoutTime } from "../../commons/helpers/Dates";
import { useMemo } from "react";
import { useAddEquipesImporterMutation } from "../../redux/api/cache";
import { Agence } from "../../models/Agence";
import { Magasin } from "../../models/Magasin";

interface AddAutreJourModalProps {
    setShowAddModalAutreJour: React.Dispatch<React.SetStateAction<boolean>>;
    agence: Agence;
    magasin: Magasin;
    date: Date;
}

export default function AddAutreJourModal(props: AddAutreJourModalProps) {
    const [addEquipesImporter] = useAddEquipesImporterMutation();
    const defaultDate = useMemo(() => {
        const today = getDateWithoutTime(new Date());
        today.setDate(today.getDay() === 1 ? today.getDate() - 2 : today.getDate() - 1);
        return today;
    }, []);

    const journeeValidator = (e: any) => required(e, 'Journée')

    const handleSubmit = async (e: any) => {
        await addEquipesImporter({ agence: props.agence.agence_cd, mag_num: props.magasin.mag_num, date: dateToBdFormat(props.date), body: { dateReference: dateToBdFormat(e.journee) } })
        props.setShowAddModalAutreJour(false);
    };

    return <CustomModal title={"Choisir la journée"} onClose={() => props.setShowAddModalAutreJour(false)} body={
        <Form ignoreModified={true} initialValues={{ journee: defaultDate }} onSubmit={handleSubmit} render={(formRenderProps: FormRenderProps) =>
            <FormElement>
                <Field id="journee" name={"journee"} component={FormDatePicker} title="Journée" validator={journeeValidator} label="Journée" />
                <div style={{ display: 'flex', marginTop: '2vh', columnGap: '5px', justifyContent: 'center' }}>
                    {formRenderProps.allowSubmit && (<Button className="blueButton" type="submit">Importer</Button>)}
                    <Button className="blueButton" onClick={() => props.setShowAddModalAutreJour(false)}>Annuler</Button>
                </div>
            </FormElement>}
        />}
    />;
}